import React, { useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Input from 'src/components/ui/Input/Input';
import Modal from '../../layouts/Modal/Modal';
import ModalListItem from '../../layouts/ModalListItem/ModalListItem';
import './AddWidgetModal.scss';

type ListItem = {
  cardType: string;
  cardImage: string;
};

export type AddWidgetModalProps = {
  isOpen: boolean;
  onClose: () => void;
  listItems: ListItem[];
};

const AddWidgetModal: React.FC<AddWidgetModalProps> = ({ isOpen, onClose, listItems }) => {
  const { t } = useTranslation();
  const sortItemsByCardType = (items: ListItem[]) => {
    return items.sort((a, b) => a.cardType.localeCompare(b.cardType));
  };

  const [hoveredImage, setHoveredImage] = useState<string | null>(null);
  const [selectedCard, setSelectedCard] = useState('');
  const [filteredItems, setFilteredItems] = useState<ListItem[]>(sortItemsByCardType(listItems));

  const handleCardChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSelectedCard(value);
    const filtered = listItems.filter(item => item.cardType.toLowerCase().includes(value.toLowerCase()));
    setFilteredItems(filtered);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="addWidgetModal w-[800px] mx-auto surface-elevated rounded-lg shadow-lg">
        <div className="flex flex-col md:flex-row justify-between h-[600px]">
          <div className="md:w-5/12 firstSection">
            <div className="pl-5 pr-5 pt-5">
              <h2 className="text-base font-bold mb-2">{t('general.add_widget')}</h2>
              <Input
                value={selectedCard}
                icon="search"
                onChange={handleCardChange}
                placeholder={t('general.search_placeholder')}
                className="pl-9 pb-2 pt-2 h-9 w-72 color-grey"
                clearable={!!selectedCard}
              />
            </div>
            <ul className="list-none mr-2 pt-4">
              {filteredItems.map(item => (
                <ModalListItem
                  key={item.cardType}
                  item={item}
                  onMouseEnter={() => setHoveredImage(item.cardImage)}
                  onMouseLeave={() => setHoveredImage(null)}
                />
              ))}
            </ul>
          </div>
          <div className="secondSection md:w-7/12	md:pr-4 mb-4 md:mb-0 flex items-center justify-center">
            {hoveredImage && <img src={hoveredImage} alt="Hovered Card" className="w-80 h-auto rounded-lg" />}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddWidgetModal;
